import Billing from "../pages/admin/billing/Billing";
import AddClient from "../pages/admin/clients/AddClient";
import Clients from "../pages/admin/clients/Clients";
import EditClient from "../pages/admin/clients/EditClient";
import ViewClient from "../pages/admin/clients/ViewClient";
import AddProduct from "../pages/admin/productsCategories/products/AddProducts";
import EditProduct from "../pages/admin/productsCategories/products/EditProduct";
import ProductDetails from "../pages/admin/productsCategories/products/ProductDetails";
import Products from "../pages/admin/productsCategories/products/Products";
import ProductsCategories from "../pages/admin/productsCategories/ProductsCategories";
import Profile from "../pages/admin/profile/Profile";
import AddQuotation from "../pages/admin/quotations/AddQuotation";
import EditQuotation from "../pages/admin/quotations/EditQuotation";
import Quotations from "../pages/admin/quotations/Quotations";
import ViewQuotation from "../pages/admin/quotations/ViewQuotation";
import AddSalesInvoice from "../pages/admin/salesInvoices/AddSalesInvoice";
import EditSalesInvoice from "../pages/admin/salesInvoices/EditSalesInvoice";
import SalesInvoices from "../pages/admin/salesInvoices/SalesInvoices";
import ViewSalesInvoice from "../pages/admin/salesInvoices/ViewSalesInvoice";
import EditEstablishment from "../pages/admin/settings/establishment/EditEstablishment";
import Establishment from "../pages/admin/settings/establishment/Establishment";
import AddUsers from "../pages/admin/users/AddUsers";
import EditUser from "../pages/admin/users/EditUser";
import UserDetails from "../pages/admin/users/UserDetails";
import Users from "../pages/admin/users/Users";

export const privateRoutes = [
  {
    path: "profile",
    element: <Profile />,
  },
  {
    path: "products-categories",
    element: <ProductsCategories />,
    permission: {
      collection: 2,
      action: 3,
    },
  },
  {
    path: "products-categories/:id/products",
    element: <Products />,
    permission: {
      collection: 2,
      action: 3,
    },
  },
  {
    path: "products-categories/:id/products/add-product",
    element: <AddProduct />,
    permission: {
      collection: 2,
      action: 1,
    },
  },
  {
    path: "products-categories/:id/products/:prod_id/edit-product",
    element: <EditProduct />,
    permission: {
      collection: 2,
      action: 2,
    },
  },
  {
    path: "products-categories/:id/products/:prod_id/view-product",
    element: <ProductDetails />,
    permission: {
      collection: 2,
      action: 3,
    },
  },
  {
    path: "billing",
    element: <Billing />,
  },
  {
    path: "settings/establishment",
    element: <Establishment />,
  },
  {
    path: "settings/establishment/edit",
    element: <EditEstablishment />,
  },
  {
    path: "users",
    element: <Users />,
    permission: {
      collection: 1,
      action: 3,
    },
  },
  {
    path: "users/create-user",
    element: <AddUsers />,
    permission: {
      collection: 1,
      action: 1,
    },
  },
  {
    path: "users/edit-user/:id",
    element: <EditUser />,
    permission: {
      collection: 1,
      action: 2,
    },
  },
  {
    path: "users/view-user/:id",
    element: <UserDetails />,
    permission: {
      collection: 1,
      action: 3,
    },
  },
  {
    path: "quotations",
    element: <Quotations />,
    permission: {
      collection: 4,
      action: 3,
    },
  },
  {
    path: "quotations/create-quotation",
    element: <AddQuotation />,
    permission: {
      collection: 4,
      action: 1,
    },
  },
  {
    path: "quotations/:id/edit-quotation",
    element: <EditQuotation />,
    permission: {
      collection: 4,
      action: 2,
    },
  },
  {
    path: "quotations/:id/view-quotation",
    element: <ViewQuotation />,
    permission: {
      collection: 4,
      action: 3,
    },
  },
  {
    path: "sales-invoices",
    element: <SalesInvoices />,
    permission: {
      collection: 5,
      action: 3,
    },
  },
  {
    path: "sales-invoices/create-invoice",
    element: <AddSalesInvoice />,
    permission: {
      collection: 5,
      action: 1,
    },
  },
  {
    path: "sales-invoices/:id/edit-invoice",
    element: <EditSalesInvoice />,
    permission: {
      collection: 5,
      action: 2,
    },
  },
  {
    path: "sales-invoices/:id/view-invoice",
    element: <ViewSalesInvoice />,
    permission: {
      collection: 5,
      action: 3,
    },
  },
  {
    path: "clients",
    element: <Clients />,
    permission: {
      collection: 3,
      action: 3,
    },
  },
  {
    path: "clients/create-client",
    element: <AddClient />,
    permission: {
      collection: 3,
      action: 1,
    },
  },
  {
    path: "clients/:id/view-client",
    element: <ViewClient />,
    permission: {
      collection: 3,
      action: 3,
    },
  },
  {
    path: "clients/:id/edit-client",
    element: <EditClient />,
    permission: {
      collection: 3,
      action: 2,
    },
  },
];
